export function readBigInt(buffer) {
  return buffer.readBigInt64LE();
}